import { $ as $E, html, type Html, Page } from 'rune-ts';
import klass from './CommerceCreatorLanding.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { footer_links } from '../../components/cells/Footer/constant';
import { BaseLayoutOptions } from '../../../features/Core/service';
import { ButtonCtaLanding } from '../../../shared/components/atoms/ButtonCtaLanding/ButtonCtaLanding';
import { isFixedElementInSection } from '../../../shared/util/elementPositionHelper';
import {
  AdSection,
  BenefitSection,
  BottomSection,
  FaqSection,
  MainSection,
  RecruitSection,
  CreatorSection,
  MoreSection,
  HeaderSection,
} from './views';
import { commerce_creator_apply_url } from './constant';

export type CommerceCreatorLandingPageData = {
  layout_options: BaseLayoutOptions;
};

export class CommerceCreatorLandingPage extends Page<CommerceCreatorLandingPageData> {
  header = new HeaderSection();
  mainSection = new MainSection();
  adSection = new AdSection();
  creatorSection = new CreatorSection();
  benefitSection = new BenefitSection();
  recruitSection = new RecruitSection();
  faqSection = new FaqSection();
  bottomSection = new BottomSection();
  moreSection = new MoreSection();
  ctaButton = new ButtonCtaLanding({
    href: commerce_creator_apply_url,
    type: 'black',
    label: '커머스 크리에이터 지원하기',
    klass: `${klass.submit}`,
    target: '_blank',
  });

  protected override template(): Html {
    const { layout_options } = this.data;
    const { is_mobile } = layout_options;

    const body = html`
      <div class="${klass.container}">
        <!--   헤더     -->
        ${this.header}

        <!--   메인     -->
        ${this.mainSection}

        <!--   광고     -->
        ${this.adSection}

        <!--   크리에이터     -->
        ${this.creatorSection}

        <!--   혜택     -->
        ${this.benefitSection}

        <!--   모집     -->
        ${this.recruitSection}

        <!--   faq     -->
        ${this.faqSection}

        <!--   하단     -->
        ${this.bottomSection}

        <!--   더보기     -->
        ${this.moreSection}

        <!--   cta 버튼     -->
        ${this.ctaButton}
      </div>
    `;

    return html`
      <div>
        ${new LayoutView(
          {
            body,
            footer_data: { ...footer_links, lang: ET.lang, is_mobile },
          },
          {
            require_top_arrow_button: false,
            full_width: true,
            has_bottom_tab_bar: false,
            selected_bottom_tab_idx: -1,
            ...layout_options,
          },
        )}
      </div>
    `;
  }

  handleScrollChangeButtonColor() {
    if (this.ctaButton.isRendered()) {
      const $current_section = $E(this.element())
        .findAll(`.${klass.container} > section`)
        .find(($section) => isFixedElementInSection(this.ctaButton.element(), $section.element()));

      if ($current_section) {
        switch ($current_section.element()) {
          case this.bottomSection.element():
          case this.moreSection.element():
            this.ctaButton.setTypeOption('hidden');
            break;
          default:
            this.ctaButton.setTypeOption('black');
            break;
        }
      }
    }
  }

  override onRender() {
    this.handleScrollChangeButtonColor();

    document.addEventListener('scroll', () => this.handleScrollChangeButtonColor(), {
      passive: true,
    });

    if (window.visualViewport) {
      window.visualViewport.onresize = () => this.handleScrollChangeButtonColor();
    }

    this.ctaButton.addEventListener('click', () => {
      if (window.ENV.is_prod && ET.lang == 'kr' && typeof window.gtag == 'function') {
        window.gtag('event', '커머스 크리에이터 지원하기', { event_category: '커머스 크리에이터 지원하기' });
      }
    });
  }
}
